export const staticText = {
  shared: {
    backToHomepage: "Back to homepage",
    signOut: "Sign out",
    save: "Save",
    cancel: "Cancel",
    emptyValue: "—",
  },
  errorFlag: {
    header: "Oops! Something went wrong.",
    description:
      "It looks like the page didn't load properly. Please try again in a moment. If the problem persists, please contact Support.",
  },
  exportButton: {
    label: "Export CSV",
    tip: "Export table to CSV",
    successMessage: "Table exported successfully",
  },
  copyLink: {
    label: "Copy link",
    tip: "Copy link to clipboard",
    success: "Link copied to clipboard",
  },
  tableColumns: {
    notAvailable: "N/A",
  },
  entryList: {
    defaultAddButtonText: "Add New",
    updating: "Updating...",
    editTooltip: "Edit",
    deleteTooltip: "Delete",
  },
  wizard: {
    back: "Back",
    cancel: "Cancel",
    continue: "Continue",
    complete: "Complete",
    confirmCancel: "Are you sure you want to close this wizard?",
    confirmCancelConfirm: "Yes, close",
    confirmCancelCancel: "No, stay",
  },
  form: {
    navigationGuard: {
      title: "Unsaved Changes",
      message: "You have unsaved changes. Are you sure you want to leave?",
      confirmText: "Leave",
      cancelText: "Stay",
    },
    cancel: "Cancel",
    submit: "Submit",
  },
  serverTimingHud: {
    panelTitle: "Server Timing",
    panelTimestamp: "Executed:",
    buttons: {
      prev: "◀ Prev",
      next: "▶ Next",
      dismiss: "Dismiss",
      response: "View Response",
      timings: "View Timings",
      serverEvents: "server events",
      minimize: "Minimized View",
    },
    na: "n/a",
  },
};
